import nodeContentRenderer from "./nodeContentRenderer";
import treeNodeRenderer from "./treeNodeRenderer";

export default {
  nodeContentRenderer,
  treeNodeRenderer,
  scaffoldBlockPxWidth: 45,
};
